import ProjectDescription from "@/components/myProjectsComp/ProjectDescription";
import ProjectDetails from "@/components/myProjectsComp/ProjectDetails";
import DocumentList from "@/components/myProjectsComp/ProjectDocumentList";
import ProjectObjectives from "@/components/myProjectsComp/ProjectObjectives";
import { useProjectStore } from "@/stores/projectStore";
import { useEffect } from "react";

const ProjectGeneral = () => {
  const { projects, selectedProject, setSelectedProject } = useProjectStore();

  // Update the screen height when the window is resized
  useEffect(() => {
    const updateSelectedProject = (id: string) => setSelectedProject(id);

    updateSelectedProject(selectedProject?.id || "string");
  }, [projects, selectedProject?.id, setSelectedProject]);

  return (
    <div className="p-6 bg-white rounded-lg space-y-6">
      <h1 className="text-rajapiNavyBlue text-xl">Information du project</h1>

      <ProjectDetails
        type={
          selectedProject && selectedProject?.type
            ? selectedProject?.type
            : "No Type"
        }
        startDate={selectedProject?.start_date ?? "No Start date"}
        deadline={selectedProject?.deadline ?? "No Deadline"}
      />
      <ProjectDescription
        description={
          selectedProject ? selectedProject.description : "No Description"
        }
      />
      <DocumentList />
      <ProjectObjectives
        objectives={
          selectedProject
            ? Array.isArray(selectedProject.objectives)
              ? selectedProject.objectives.join(", ")
              : selectedProject.objectives || "No Objectives"
            : "No Objectives"
        }
      />
    </div>
  );
};

export default ProjectGeneral;
